<main style="width: 100%">
    <section class="topimg about-header">
        <div class="container">
            <div class="row">
                <div class="col-xl-6 col-lg-6 col-sm-12 col-12 d-flex align-items-center justify-content-center"
                    data-aos="fade-up" data-aos-duration="2000">
                    <div>
                        <h3 class="title-text">
                            Our Clients
                        </h3>
                        <p class="title-text1">
                          We empower our clients with innovative, secure, and scalable IT solutions that drive digital transformation, inspire growth, and create lasting business impact.
                        </p>
                    </div>
                </div>
                <div class="col-xl-6 col-lg-6 col-sm-12 col-12 d-flex align-items-center justify-content-center"
                    data-aos="fade-up" data-aos-duration="2000">
                    <div class="header-img"></div>
                </div>
            </div>
        </div>
    </section>

    <section class="custom-app">
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <div class="img-marquee">
                        <ul>
                            <li><img src="assets/img/client-logo/npci.png" alt="National Payments Corporation of India">
                            </li>
                            <li><img src="assets/img/client-logo/tata-aia.png" alt="Tata AIA"></li>
                            <li><img src="assets/img/client-logo/pnb-metlife.png" alt="PNB Metlife"></li>
                            <li><img src="assets/img/client-logo/edelweiss.png" alt="Edelweiss Life Insurance"></li>
                            <li><img src="assets/img/client-logo/hdfc-ergo.png" alt="HDFC Ergo"></li>
                            <li><img src="assets/img/client-logo/tata-aig.png" alt="TATA AIG Insurance "></li>
                            <li><img src="assets/img/client-logo/icici-prudential-life-insurance.png"
                                    alt="ICICI Prudential Life Insurance"></li>
                            <li><img src="assets/img/client-logo/jlr.png" alt="Jaguar Land Rover"> </li>
                            <li><img src="assets/img/client-logo/hdfc-life.png" alt="HDFC Life">
                            </li>
                            <li><img src="assets/img/client-logo/smfg.png" alt="smfg"></li>
                            <li><img src="assets/img/client-logo/mahindra-insurance-brokers.png"
                                    alt="Mahindra Insurance Brokers"></li>
                            <li><img src="assets/img/client-logo/axis-finance.png" alt="Axis Finance"></li>
                            <li><img src="assets/img/client-logo/ageas-federal.png" alt="Ageas Federal"></li>
                            <li><img src="assets/img/client-logo/tata-capital.png" alt="TATA Capital">                            </li>
                            <li><img src="assets/img/client-logo/euronet.png" alt="Euronet"></li>
                            <li><img src="assets/img/client-logo/alliance-insurance-brokers.png"
                                    alt="Alliance Insurance Brokers"></li>
                            <li><img src="assets/img/client-logo/alphavima.png" alt="Alphavima"></li>
                            <li><img src="assets/img/client-logo/payso.png" alt="payso"></li>
                            <li><img src="assets/img/client-logo/razorpay.png" alt="Razorpay"></li>
                            <li><img src="assets/img/client-logo/1-silver-bullet.png" alt="1 Silver Bullet"></li>
                            <li><img src="assets/img/client-logo/link-group.png" alt="Link Group"></li>
                            <li><img src="assets/img/client-logo/thomas-cook.png" alt="Thomas Cook"></li>
                             <li><img src="assets/img/client-logo/hr-align.png" alt="HR Align"></li>
                            <li><img src="assets/img/client-logo/billabong-high-international-school.png"
                                    alt="Billabong High International School"></li> 
                          </ul>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <!-- OUR INDUSTRY SECTION -->
    <app-our-services></app-our-services>
</main>